module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1506-ebd89a4d7503df2424c066c78e9f9e91.png";